import { KitcenSinkRow } from 'store-types';

type DiffRowType = KitcenSinkRow['type'];

interface DiffRow {
  type: DiffRowType;
  url: string;
  token: string;
  slug: string;
  title: string;
  id: string;
}

interface DiffResponse {
  headers: { 'cache-control'?: string };
  data: {
    diff: {
      data: DiffRow[] | null;
      dataToken: string;
      fullRefreshToken: string;
      lastUpdated: number;
    };
  };
}

const parseRow = (row: DiffRow): KitcenSinkRow => {
  return {
    type: row.type,
    url: row.url,
    token: row.token,
    slug: row.slug,
    title: row.title,
    id: row.id,
  };
};

const parseCacheMaxAgeSeconds = (headers: { 'cache-control'?: string } | undefined) => {
  try {
    const cacheHeaders = headers && headers['cache-control'];
    const maxAgeMatches = cacheHeaders.match(/max-age=(\d+)/);
    const maxAge = maxAgeMatches ? Number(maxAgeMatches[1]) : -1;

    return maxAge;
  } catch (e) {
    // no-op
  }

  return -1;
};

export default (response: DiffResponse): {
  lastUpdated: number;
  fullRefreshToken: string;
  dataToken: string;
  rows: KitcenSinkRow[] | null;
  maxAgeHeaderMs: number;
} => {
  const { headers } = response;
  const { diff } = response.data;
  const { data, dataToken, fullRefreshToken, lastUpdated } = diff;

  return {
    lastUpdated,
    fullRefreshToken,
    dataToken,
    rows: data != null ? data.map(row => parseRow(row)) : null,
    maxAgeHeaderMs: parseCacheMaxAgeSeconds(headers) * 1000,
  };
};